import React from 'react';
import PropTypes from 'prop-types';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import pointerOnHover from 'lib/css/pointerOnHover';

function AttributeSubCategoryScoringRow({
  categoryName,
  data,
  isEditing,
  onUpdate,
  calculatedScores,
}) {
  const toolTipGroupMaxScore = () => (
    <Tooltip>
      <div>Sub group max score</div>
    </Tooltip>
  );

  return (
    <tr className={pointerOnHover}>
      <td className="text-center pt-3">{categoryName}</td>
      <td className="text-center pt-3">{data.subCategoryName}</td>
      <td className="text-center pt-3">{data.attributesCount}</td>
      <td className="text-center pt-3">{data.foodTotalAttributes}</td>
      <td>
        <Form.Control
          className="text-center"
          type="number"
          min={0}
          step={1}
          value={data.FdScore.user_input_total_attributes_count || ''}
          onChange={e => onUpdate(data.subCategoryName, 'FdScore', e.target.value)}
          disabled={!isEditing}
        />
      </td>
      <td className="text-center pt-3">
        <OverlayTrigger overlay={toolTipGroupMaxScore()} placement="top">
          <span>{Number(calculatedScores.fd_max_score?.toFixed(2))}</span>
        </OverlayTrigger>
      </td>
      <td className="text-center pt-3">{data.bevTotalAttributes}</td>
      <td>
        <Form.Control
          className="text-center"
          type="number"
          min={0}
          step={1}
          value={data.BevScore.user_input_total_attributes_count || ''}
          onChange={e => onUpdate(data.subCategoryName, 'BevScore', e.target.value)}
          disabled={!isEditing}
        />
      </td>
      <td className="text-center pt-3">
        <OverlayTrigger overlay={toolTipGroupMaxScore()} placement="top">
          <span>{Number(calculatedScores.bev_max_score?.toFixed(2))}</span>
        </OverlayTrigger>
      </td>
      <td className="text-center pt-3">{data.opsTotalAttributes}</td>
      <td>
        <Form.Control
          className="text-center"
          type="number"
          min={0}
          step={1}
          value={data.OpsScore.user_input_total_attributes_count || ''}
          onChange={e => onUpdate(data.subCategoryName, 'OpsScore', e.target.value)}
          disabled={!isEditing}
        />
      </td>
      <td className="text-center pt-3">
        <OverlayTrigger overlay={toolTipGroupMaxScore()} placement="top">
          <span>{Number(calculatedScores.ops_max_score?.toFixed(2))}</span>
        </OverlayTrigger>
      </td>
    </tr>
  );
}

AttributeSubCategoryScoringRow.propTypes = {
  categoryName: PropTypes.string.isRequired,
  data: PropTypes.shape({
    subCategoryName: PropTypes.string.isRequired,
    attributesCount: PropTypes.number.isRequired,
    foodTotalAttributes: PropTypes.number.isRequired,
    bevTotalAttributes: PropTypes.number.isRequired,
    opsTotalAttributes: PropTypes.number.isRequired,
    FdScore: PropTypes.object.isRequired,
    BevScore: PropTypes.object.isRequired,
    OpsScore: PropTypes.object.isRequired,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
  calculatedScores: PropTypes.shape({
    fd_max_score: PropTypes.number.isRequired,
    bev_max_score: PropTypes.number.isRequired,
    ops_max_score: PropTypes.number.isRequired,
  }).isRequired,
};

export default AttributeSubCategoryScoringRow;
